/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file LocalChoice component
 * @author Dustin Gage
 */

import React, { memo, ReactElement, useMemo } from "react";

import { useSettings } from "../../api/use-settings";
import { LocaleLink } from "./LocaleLink";
import { ILocaleAndName } from "../../types";

interface IProps {}

export const LocaleChoice = memo(function LocaleChoice(props: IProps): ReactElement {
	const {} = props;
	const { currentLocale, locales } = useSettings();

	const kvps = useMemo(() => {
		const ret: ILocaleAndName[] = [];
		Object.keys(locales).forEach((key) => {
			ret.push({ key: key, name: locales[key] });
		});
		return ret;
	}, [locales]);

	return (
		<div className="dropdown">
			<a
				className="btn btn-secondary dropdown-toggle"
				id="localeDropdownButton"
				data-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
				href="#"
			>
				{locales[currentLocale]}
			</a>
			<div className="dropdown-menu" aria-labelledby="localeDropdownButton">
				{kvps.map((kvp) => (
					<LocaleLink key={kvp.key} locale={kvp} />
				))}
			</div>
		</div>
	);
});
